import { CommonModule, DatePipe } from '@angular/common';
import { NgModule, Injectable, Inject, OnInit, ModuleWithProviders  } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { MaterialModule } from '../../shared/material.module';
import { DashboardComponent } from './pages/dashboard.component';
import { DashboardService } from './dashboard.service';
import { ComponentViewComponent } from './components/component-view/component-view.component';
import { FleetViewComponent } from './components/fleet-view/fleet-view.component';
import { ComponentViewPrintComponent } from './components/component-view-print/component-view-print.component';
import { FleetViewPrintComponent } from './components/fleet-view-print/fleet-view-print.component';
import { SharedModule } from '../../shared/shared.module';
import { WidgetsModule } from '../widgets/widgets.module';
import { ComponentWearComponent } from './components/component-wear/component-wear.component';
import { FleetReportConfigurationComponent } from './fleet-report-configuration/fleet-report-configuration.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../GET_NEW_UI/search-form-analysisreporting/search-form-analysisreporting.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { InventoryReportConfigurationComponent } from './inventory-report-configuration/inventory-report-configuration.component';

export const equipmentTableRoutes: Routes = [{
    path: '',
    component: DashboardComponent,
    children: [
        { path: '', component: ComponentViewComponent }, // FleetViewComponent
        { path: 'fleet', redirectTo: 'fleet/1' },
        
        { path: 'fleet/:page', component: FleetViewComponent },
        { path: 'fleet/:page', component: FleetViewComponent },
        { path: 'fleet-print/:printId', component: FleetViewPrintComponent },
        { path: 'components', redirectTo: 'components/1' },
        { path: 'components/:page', component: ComponentViewComponent },
        { path: 'components-print/:printId', component: ComponentViewPrintComponent },
        { path: 'wears', redirectTo: 'wears/1' },
        { path: 'wears/:page', component: ComponentWearComponent },
    ]
}];

@NgModule({
    imports: [CommonModule, MaterialModule,
        FormsModule, ReactiveFormsModule,
        RouterModule.forChild(equipmentTableRoutes), SharedModule, WidgetsModule],
    declarations: [
        DashboardComponent,
        ComponentViewComponent,
        FleetViewComponent,
        ComponentViewPrintComponent,
        FleetViewPrintComponent,
        ComponentWearComponent,
        FleetReportConfigurationComponent,
        InventoryReportConfigurationComponent
    ],
    providers: [DatePipe,
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
    ],
    exports: [DashboardComponent, MaterialModule, RouterModule]
})
export class DashboardModule {
    static forRoot(): ModuleWithProviders<DashboardModule> {
        return {
            ngModule: DashboardModule,
            providers: [DashboardService],
        }
    }
}
